"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "oplus-table-wrapper" };
const _hoisted_2 = { class: "oplus-table" };
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("thead", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("tr", null, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, "タイムプラン名"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, "から"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, "まで"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, "必要人数(Max)"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, [
            /*#__PURE__*/ (0, vue_2.createCommentVNode)(" For edit icon ")
        ])
    ])
], -1 /* HOISTED */);
const vue_3 = require("vue");
const SectionTemplateTableRow_vue_1 = __importDefault(require("./SectionTemplateTableRow.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SectionTemplateTable',
    props: {
        roleSectionTemplates: {
            type: Array,
            required: true
        },
    },
    emits: ["emit-template-data", "emit-template-delete"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const showingEditBtnTempId = (0, vue_3.ref)(undefined);
        const emits = __emit;
        function handleTemplateEmitEdit(template) {
            emits("emit-template-data", template?.getId());
        }
        function handleTemplateEmitDelete(template) {
            emits("emit-template-delete", template?.getId());
        }
        function handleShowEditButton(template) {
            showingEditBtnTempId.value = template?.getId();
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("table", _hoisted_2, [
                    _hoisted_3,
                    (0, vue_2.createElementVNode)("tbody", null, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(props.roleSectionTemplates, (template) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SectionTemplateTableRow_vue_1.default, {
                                key: template.getId(),
                                template: template,
                                "show-edit-buttons": showingEditBtnTempId.value == template.getId(),
                                onEmitTemplateEdit: handleTemplateEmitEdit,
                                onEmitTemplateDelete: handleTemplateEmitDelete,
                                onEmitShowEditButton: handleShowEditButton
                            }, null, 8 /* PROPS */, ["template", "show-edit-buttons"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ]));
        };
    }
});
